import { Controller } from "@hotwired/stimulus"
import { requestConfirm } from "../util/confirm_modal"
import { turboFetch } from "../util/common"

export default class extends Controller {
  static values = {
    url: String
  }

  async submit(event) {
    event.preventDefault()
    event.stopPropagation()

    const confirmed = await requestConfirm({ modal: "reset-password" })
    if (!confirmed) return

    this.element.disabled = true

    try {
      await turboFetch(this.urlValue, { method: "POST" })
    } catch (error) {
      console.error("Reset password request failed:", error)
    } finally {
      this.element.disabled = false
    }
  }
}
